import React from 'react';
import { func, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { supportedLanguages } from '../../util/translations';
import { Icon } from '..';

import css from './LanguagePill.module.css';

/**
 * The language pill from the Components board ("🌐 English ▾"): the current language, which
 * opens the language modal (`onClick`; the modal stays where it is). Screen readers hear
 * "Choose a language, English".
 */
const LanguagePill = props => {
  const { rootClassName, className, onClick } = props;
  const intl = useIntl();
  const current = supportedLanguages.find(l => l.code === intl.locale) || supportedLanguages[0];
  return (
    <button
      type="button"
      className={classNames(rootClassName || css.root, className)}
      onClick={onClick}
      aria-haspopup="dialog"
    >
      <Icon name="globe" size={16} className={css.icon} />
      <span className={css.hidden}>
        <FormattedMessage id="LanguageModal.title" />
      </span>
      <span lang={current.code}>{current.language}</span>
      <Icon name="chevronDown" size={12} className={css.caret} />
    </button>
  );
};

LanguagePill.defaultProps = { rootClassName: null, className: null };

LanguagePill.propTypes = {
  rootClassName: string,
  className: string,
  onClick: func.isRequired,
};

export default LanguagePill;
